export default "__VITE_ASSET__BbY6_SYW__"